import React, { lazy, memo, Suspense } from 'react';
import type { MailListFilterButtonProps } from './schema/MailListFilterButtonProps';

const LazyMailListFilterButton = lazy(
    () => import(/* webpackChunkName: "MailListFilterButton" */ './components/MailListFilterButton')
);

export const MailListFilterButton = memo((props: MailListFilterButtonProps) => (
    <Suspense fallback={<span aria-hidden="true" />}>
        <LazyMailListFilterButton {...props} />
    </Suspense>
));

export { getActiveMailListFilterPropsForSelectedView } from './utils/getActiveMailListFilterPropsForSelectedView';
export { onMailListFilterClickCallback } from './utils/onMailListFilterClickCallback';
